import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './EventDetails.css';
import { FaArrowLeft } from 'react-icons/fa';
import { useAuth } from '../../AuthContext';

const EventDetails = () => {
  const { token } = useAuth();
  const { state } = useLocation();
  const navigate = useNavigate();
  const event = state?.event;

  useEffect(() => {
    if (token) {
      console.log("🔑 [AUTH TOKEN] Event Details Token:", token);
    }
  }, [token]);

  if (!event) {
    return (
      <div className="event-details-container">
        <h3>Event Details</h3>
        <p>No event data available. Please select an event from the list.</p>
        <button
          className="back-button"
          onClick={() => navigate('/events')}
        >
          Back to Events
        </button>
      </div>
    );
  }

  return (
    <div className="event-details-container">
         <button
        className="back-button"
        onClick={() => navigate('/events')}
    
      >
        <FaArrowLeft />
      </button>
      <h3>Event Details</h3>
      <div className="event-details-card">
        <h4 className="event-details-title">{event.eventName}</h4>
        <p className="event-details-type"><strong>Type:</strong> {event.eventType}</p>
        <p className="event-details-date"><strong>Date:</strong> {event.eventDate}</p>
        <p className="event-details-location"><strong>Location:</strong> {event.location}</p>
        <p className="event-details-duration"><strong>Duration:</strong> {event.duration}</p>
        <p className="event-details-description"><strong>Description:</strong> {event.eventDescription}</p>
      </div>
     
    </div>
  );
};

export default EventDetails;